export const SET_CURRENT_PREPAID_BALANCE = "SET_CURRENT_PREPAID_BALANCE";
